__turbopack_context__.v({
  "hiddenInMobile": "Y43rWq_hiddenInMobile",
  "leftContent": "Y43rWq_leftContent",
  "modalBody": "Y43rWq_modalBody",
  "modalContent": "Y43rWq_modalContent",
  "modalFooterMobile": "Y43rWq_modalFooterMobile",
  "modalHeader": "Y43rWq_modalHeader",
  "restaurant": "Y43rWq_restaurant",
  "rightContent": "Y43rWq_rightContent",
  "rightFooter": "Y43rWq_rightFooter",
  "searchInputContainer": "Y43rWq_searchInputContainer",
  "secondary": "Y43rWq_secondary",
});
